module.exports = __webpack_public_path__ + "img/tooltipSSL.530d2400.svg";